function getCookieDomainAttr() {
  const isLocalhost = ["localhost", "127.0.0.1"].includes(location.hostname);

  return isLocalhost || !process.env.VUE_APP_COOKIE_DOMAIN
    ? ""
    : `domain=${process.env.VUE_APP_COOKIE_DOMAIN};`;
}

export function createSessionCookie(token = "") {
  if (token) {
    console.debug("Session started.");

    const date = new Date();
    const time = date.getTime() + 72 * 60 * 60 * 1000; // 3 days / 72 hours
    const expiration = new Date(time);

    const cookieName = `auth0_vue_session_token`;
    const cookieExpires = `expires=${expiration.toUTCString()};`;
    const cookieDomain = getCookieDomainAttr();
    const cookiePath = "path=/;";
    const cookieSameSite = "samesite=lax;";
    const cookieSecure = location.protocol === "https:" ? "secure;" : "";

    document.cookie = `${cookieName}=${token};${cookiePath}${cookieExpires}${cookieDomain}${cookieSameSite}${cookieSecure}`;
  }
}

export function deleteSessionCookie() {
  console.debug("Session ended.");

  const cookieDomain = getCookieDomainAttr();
  const expired = new Date(0).toUTCString();

  document.cookie.split(";").forEach(function (c) {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, `=;expires=${expired};path=/;${cookieDomain}`);
  });
}
